import React, { Component, Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// PublicLayout is tiny (3 lines) — import eagerly so withPublic() works reliably
import PublicLayout from "./components/common/PublicLayout";

// Lazy-load all heavy page content — each becomes its own JS chunk
const StudentLayout  = lazy(() => import("./containers/Students/StudentLayout"));
const AdminLayout    = lazy(() => import("./containers/admin/adminLayout"));
const TeacherLayout  = lazy(() => import("./containers/Teachers/TeachersLayout"));
const OrgAdminLayout = lazy(() => import("./containers/OrgAdmin/OrgAdminLayout"));
const AuthLayout     = lazy(() => import("./containers/Authentication/AuthLayout"));
const VerifyLayout   = lazy(() => import("./containers/verification/VerifyLayout"));
const EmailVerify    = lazy(() => import("./components/verification/emailVerify"));
const ChangePassword = lazy(() => import("./components/verification/changePassword"));
const Contact        = lazy(() => import("./components/ContactForm/Contact"));
const Subscription   = lazy(() => import("./components/Subscription/Subscription_card"));
const certificate    = lazy(() => import("./components/Students/Certificatee/certificatee"));
const StudentData    = lazy(() => import("./components/Teachers/Assignment/StudentData"));
const PleaseWaitModal  = lazy(() => import("./components/Share/PleaseWaitModal"));
const SystemCheckModal = lazy(() => import("./components/Share/SystemCheckModal"));
const HomePage       = lazy(() => import("./components/HomePage/HomePage"));
const CourseDetail   = lazy(() => import("./components/CourseDetail/CourseDetail"));
const CoursesPage    = lazy(() => import("./components/CoursesPage/CoursesPage"));
const ResetPassword  = lazy(() => import("./components/Reset Password/ResetPassword"));
const Message        = lazy(() => import("./components/Reset Password/Meassage"));
const CareerPathPage = lazy(() => import("./components/public/CareerPathPage"));
const EnterprisePage = lazy(() => import("./components/public/EnterprisePage"));
const ResourcesPage  = lazy(() => import("./components/public/ResourcesPage"));
const AboutPage      = lazy(() => import("./components/public/AboutPage"));

const PageLoader = () => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#f8f9fa" }}>
    <div style={{ textAlign: "center" }}>
      <div style={{ width: 40, height: 40, border: "3px solid #e5e7eb", borderTopColor: "#0056d2", borderRadius: "50%", animation: "spin 0.7s linear infinite", margin: "0 auto 12px" }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <p style={{ color: "#6b7280", fontSize: 14, margin: 0 }}>Loading…</p>
    </div>
  </div>
);

/* Wrap a component in the shared public layout */
const withPublic = (Comp) => (props) => (
  <PublicLayout>
    <Comp {...props} />
  </PublicLayout>
);

const PublicHomePage     = withPublic(HomePage);
const PublicCoursesPage  = withPublic(CoursesPage);
const PublicCourseDetail = withPublic(CourseDetail);
const PublicContact      = withPublic(Contact);
const PublicSubscription = withPublic(Subscription);
const PublicCareerPath   = withPublic(CareerPathPage);
const PublicProgram      = withPublic(CareerPathPage);
const PublicEnterprise   = withPublic(EnterprisePage);
const PublicResources    = withPublic(ResourcesPage);
const PublicAbout        = withPublic(AboutPage);

export default class Routes extends Component {
  render() {
    const loginType = localStorage.getItem("loginType") || sessionStorage.getItem("loginType");
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    const { location } = this.props;


    let route;
    if (!token) {
      route = <Redirect to={"/login"} />;
    } else if (loginType === "student") {
      route = <Route path="/student" component={StudentLayout} />;
    } else if (loginType === "teacher") {
      route = <Route path="/teacher" component={TeacherLayout} />;
    } else if (loginType === "superadmin") {
      route = <Route path="/admin" component={AdminLayout} />;
    } else {
      route = <Redirect to={"/login"} />;
    }

    return (
      <Suspense fallback={<PageLoader />}>
        <Switch>
          {/* auth / verify — no public header */}
          <Route path="/StudentData/:id" component={StudentData} />
          <Route path="/register" component={AuthLayout} />
          <Route path="/register-success" component={AuthLayout} />
          <Route path="/verification" component={VerifyLayout} />
          <Route path="/verify-success" component={VerifyLayout} />
          <Route path="/PleaseWait" component={PleaseWaitModal} />
          <Route path="/SystemCheck" component={SystemCheckModal} />
          <Route path="/change-password/:id/:token" component={ChangePassword} />
          <Route path="/email-verification/:id" component={EmailVerify} />
          <Route path="/orgadmin" component={OrgAdminLayout} />
          <Route exact path="/login" component={AuthLayout} />
          <Route path="/lms/reset-password/:email" component={ResetPassword} />
          <Route path="/lms/message" component={Message} />
          <Route path="/certificate" component={certificate} />

          {/* public pages — shared header */}
          <Route exact path="/" component={PublicHomePage} />
          <Route path="/courses" component={PublicCoursesPage} />
          <Route path="/course/:slugId" component={PublicCourseDetail} />
          <Route path="/contact" component={PublicContact} />
          <Route path="/subscription" component={PublicSubscription} />

          {/* career paths & programs */}
          <Route path="/career-paths/:slug" component={PublicCareerPath} />
          <Route path="/programs/:slug" component={PublicProgram} />

          {/* enterprise / for business */}
          <Route path="/enterprise/:page" component={PublicEnterprise} />

          {/* resources */}
          <Route path="/resources/:type" component={PublicResources} />

          {/* about */}
          <Route exact path="/about" component={PublicAbout} />
          <Route path="/about/:slug" component={PublicAbout} />

          {route}
        </Switch>
      </Suspense>
    );
  }
}
